<template lang="html">
  <aside class="sidebar" :class="sidebarClasses">
    <div class="close-nav" @click="closeNav">
      <Sprite name="close" />
    </div>

    <div class="sidebar-inner">
      <div class="top">
        <Navigation :whiteLabel="whiteLabel" @closeNav="closeNav" />
      </div>

      <div class="menu">
        <Permissions
          :permissions="currentUser.permissions"
          :requireAll="{company: ['list']}">
          <router-link @click.native="closeNav" :to="{name: 'admin-sites'}">
            <div>
              <Sprite name="moderate" />
              <span>Website Moderation</span>
            </div>
          </router-link>
        </Permissions>

        <Permissions
          :permissions="currentUser.permissions"
          :requireAll="{company: ['list']}">
          <router-link @click.native="closeNav" :to="{name: 'companies'}">
            <div>
              <Sprite name="company" />
              <span>Companies</span>
            </div>
          </router-link>
        </Permissions>

        <Permissions
          :permissions="currentUser.permissions"
          :requireAll="{user: ['list']}">
          <router-link @click.native="closeNav" :to="{name: 'users'}">
            <div>
              <Sprite name="user" />
              <span>Users</span>
            </div>
          </router-link>
        </Permissions>

        <Permissions
          :permissions="currentUser.permissions"
          :requireAll="{list_type: ['create', 'update', 'delete']}">
          <router-link :to="{name: 'list-types'}">
            <div>
              <Sprite name="list"/>
              <span>Widgets</span>
            </div>
          </router-link>
        </Permissions>

        <Permissions
          :permissions="currentUser.permissions"
          :requireAll="{user: ['list']}">
          <router-link @click.native="closeNav" :to="{name: 'admin-actions'}">
            <div>
              <Sprite name="gear" />
              <span>Actions</span>
            </div>
          </router-link>
        </Permissions>

        <Permissions
          :permissions="currentUser.permissions"
          :requireAll="{theme: ['create', 'update', 'delete']}">
          <router-link :to="{name: 'themes'}">
            <div>
              <Sprite name="pallette"/>
              <span>Themes</span>
            </div>
          </router-link>
        </Permissions>

        <router-link v-if="currentUser.admin" :to="{name: 'templates'}">
          <div>
            <Sprite name="templates"/>
            <span>Templates</span>
          </div>
        </router-link>
      </div>
    </div>
  </aside>
</template>

<script>
import {mapState} from 'vuex'

import Navigation from '@/components/Navigation'
import Sprite from '@/components/Sprite'
import Permissions from '@/components/Permissions'

export default {
  name: 'Sidebar',

  props: {
    navActive: Boolean,
    whiteLabel: Boolean
  },

  components: {
    Navigation,
    Sprite,
    Permissions
  },

  computed: {
    ...mapState(['currentUser']),

    sidebarClasses() {
      return [
        {'is-active': this.navActive},
        {'is-collapsed': this.collapse}
      ]
    },

    collapse() {
      return this.$route.meta.hideSidebar
    }
  },

  methods: {
    closeNav() {
      this.$emit('closeNav')
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/base/animations'
@import '../stylesheets/helpers/mixins'

.sidebar
  position: absolute
  width: 100%
  transform: translate(-100%)
  transition: all .5s ease-in-out
  z-index: 5
  overflow: scroll
  -webkit-overflow-scrolling: touch
  display: flex
  background-image: url('~@/assets/triangles.webp')
  background-size: cover

  &:before
    content: ''
    background: rgba(50, 50, 50, 0.9)
    width: 100%
    height: 100%
    left: 0
    top: 0
    position: absolute
    pointer-events: none

  &.is-collapsed
    width: 0
    flex-basis: 0

    .menu
      opacity: 0!important
      transition: opacity .2s ease-in-out

    + .content
      .burger
        display: none

    .sidebar-inner
      flex-basis: 0

  &.is-active
    transform: translateX(0)

  @include media($media-gt-small)
    width: $sidebar-width

  @include media($media-gt-medium)
    position: relative
    height: auto
    transform: none
    flex-basis: $sidebar-width
    z-index: 0

    .animate &
      animation: sidebar .75s ease-in-out

  .sidebar-inner
    display: flex
    flex-direction: column
    justify-content: space-between
    transition: all .5s ease-in-out
    flex-basis: 100%
    width: 100%

    @include media($media-gt-small)
      flex-basis: $sidebar-width
      height: calc(100vh - #{$header-height})

      .animate &
        animation: fadeIn .5s .5s ease-in-out
        animation-fill-mode: forwards
        opacity: 0

  .close-nav
    display: none

    @include media($media-lt-small)
      display: block
      position: fixed
      z-index: 1
      top: $gap-small
      right: $gap-small

      .sprite
        fill: #fff
        width: 20px
        height: 20px

  .credits
    color: #fff
    text-transform: uppercase
    text-align: center
    margin: $gap-small 0

    .count, .add-more
      margin: 6px 0
      padding: 0

    .add-more
      font-size: 10px
      display: block

  .top
    margin-bottom: $gap-small

  a
    border-top: 1px solid rgba(255, 255, 255, 0.05)
    color: #fff!important
    opacity: 0.5
    transition: opacity .2s ease-in-out
    width: 100%
    display: flex
    padding: 20px $gap-medium

    &.is-active

    span
      margin-left: 15px

    &:hover
      opacity: 1
</style>
